// extracted by mini-css-extract-plugin
export var postnav = "postNav-module--postnav--3mDDd";
export var postnav__head = "postNav-module--postnav__head--301EZ";
export var postnav__title = "postNav-module--postnav__title--1_gx8";